import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { authFetch, useAuth } from "../context/AuthContext";

const SIGN_GLYPH = {
    Aries: "♈", Taurus: "♉", Gemini: "♊", Cancer: "♋", Leo: "♌", Virgo: "♍",
    Libra: "♎", Scorpio: "♏", Sagittarius: "♐", Capricorn: "♑", Aquarius: "♒", Pisces: "♓",
};

const PLANET_GLYPH = {
    Sun: "☉", Moon: "☽", Mercury: "☿", Venus: "♀", Mars: "♂",
    Jupiter: "♃", Saturn: "♄", Uranus: "♅", Neptune: "♆", Pluto: "♇", Rising: "↑",
};

export default function BirthChart() {
    const { user } = useAuth();
    const [chart, setChart] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        authFetch("get", "/profile/birth-chart")
            .then((r) => setChart(r.data))
            .catch((e) => setError(e.response?.status === 402 ? "premium" : "error"))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <><Navbar /><main className="min-h-screen flex items-center justify-center"><p className="text-muted">Mapping the heavens...</p></main></>;

    if (error === "premium") {
        return (
            <>
                <Navbar />
                <main className="min-h-screen pt-28 pb-12 px-6">
                    <div className="max-w-2xl mx-auto glass-gold p-12 text-center">
                        <p className="label-tracking text-gold">Premium Feature</p>
                        <h1 className="font-serif text-5xl mt-3">Your Natal Birth Chart</h1>
                        <p className="text-muted mt-4 leading-relaxed">
                            The complete map of the heavens at the moment of your arrival. All ten planets,
                            twelve houses, and the geometry of your fate — woven in gold.
                        </p>
                        <Link to="/subscribe" className="btn-gold-solid inline-block mt-8" data-testid="unlock-chart">
                            Unlock Premium
                        </Link>
                    </div>
                </main>
            </>
        );
    }

    return (
        <>
            <Navbar />
            <main className="min-h-screen pt-28 pb-12 px-6">
                <div className="max-w-5xl mx-auto">
                    <p className="label-tracking text-gold">Your Natal Chart</p>
                    <h1 className="font-serif text-5xl mt-2">{user?.name}'s Sky</h1>
                    <p className="text-muted mt-2">{chart?.birth_date} · {chart?.birth_time} · {chart?.birth_location}</p>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-8">
                        {/* Planets */}
                        <div className="glass-gold p-8" data-testid="planets-card">
                            <p className="label-tracking text-gold">The Planets</p>
                            <h2 className="font-serif text-3xl mt-2">Where the wanderers stood</h2>
                            <div className="grid grid-cols-2 gap-3 mt-6">
                                {Object.entries(chart?.planets || {}).map(([planet, sign]) => (
                                    <div key={planet} className="flex items-center gap-3 p-3 rounded-xl bg-white/5 border border-white/10">
                                        <span className="text-2xl text-gold font-serif">{PLANET_GLYPH[planet]}</span>
                                        <div>
                                            <p className="label-tracking text-xs">{planet}</p>
                                            <p className="font-serif text-lg">{SIGN_GLYPH[sign]} {sign}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Houses */}
                        <div className="glass-gold p-8" data-testid="houses-card">
                            <p className="label-tracking text-gold">The Twelve Houses</p>
                            <h2 className="font-serif text-3xl mt-2">The chambers of life</h2>
                            <div className="grid grid-cols-2 gap-3 mt-6">
                                {(chart?.houses || []).map((h) => (
                                    <div key={h.house} className="p-3 rounded-xl bg-white/5 border border-white/10">
                                        <p className="label-tracking text-xs">House {h.house}</p>
                                        <p className="font-serif text-lg mt-1">{SIGN_GLYPH[h.sign]} {h.sign}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}
